import { render } from "./whois.vue?vue&type=template&id=08de56ce&ts=true"
import script from "./whois.vue?vue&type=script&lang=ts"
export * from "./whois.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/whois.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08de56ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08de56ce', __exports__)) {
    api.reload('08de56ce', __exports__)
  }
  
  module.hot.accept("./whois.vue?vue&type=template&id=08de56ce&ts=true", () => {
    api.rerender('08de56ce', render)
  })

}


export default __exports__